import React from 'react';
import { Button } from './Button.styles';
var ButtonCmp = function (_a) {
    var mode = _a.mode, children = _a.children, onClick = _a.onClick, style = _a.style;
    return (React.createElement(Button, { style: style, onClick: onClick, mode: mode }, children));
};
export default ButtonCmp;
